import React from 'react';
import PropTypes, { bool } from 'prop-types';
import { Dropdown, Menu } from 'antd';
import Icon from 'components/common/Icon';

const DropdownMenu = (props) => {
  const haveItems = props.items?.some((item) => item.allowed !== false);
  if (!haveItems && props.hideEmpty) {
    return null;
  }
  return (
    <Dropdown
      overlay={
        <Menu>
          {props.items &&
            props.items.map((item, index) => {
              if (item === 'divider') {
                return <Menu.Divider key={index} />;
              }
              if (item.allowed !== false) {
                return (
                  <Menu.Item key={index} onClick={item.onClick} className={item.className}>
                    {item.icon ? <Icon fixedSize className="gx-mr-2" name={item.icon} /> : null}
                    {item.content}
                  </Menu.Item>
                );
              }
              return null;
            })}
        </Menu>
      }
      placement={props.placement}
      trigger={props.trigger ? props.trigger : ['click']}
      getPopupContainer={
        props.popupContainer
          ? props.popupContainer
          : () => {
              if (props.container) {
                return document.getElementById(props.container) || document.getElementsByClassName(props.container)[0];
              } else {
                return document.body;
              }
            }
      }
    >
      {props.content}
    </Dropdown>
  );
};

export default DropdownMenu;

DropdownMenu.defaultProps = {
  placement: 'bottomRight',
};

DropdownMenu.propTypes = {
  container: PropTypes.string,
  placement: PropTypes.string,
  trigger: PropTypes.array,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        className: PropTypes.string,
        allowed: PropTypes.bool,
        content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        onClick: PropTypes.func,
      }),
      PropTypes.oneOf(['divider']),
    ]),
  ),
  content: PropTypes.element,
  hideEmpty: bool,
  popupContainer: PropTypes.func,
};
